import "react-day-picker/style.css";
import { Navigate, Route, Routes } from 'react-router-dom';
import { useGetAllowedMenus } from './API/rest.role';
import { isAllowedPermission } from './lib/utils';
import { LayoutRoot } from './pages/LayoutRoot/layoutRoot';
import { ProductPage } from './pages/LayoutRoot/pages/Master/Product/page.product';

function App() {

  // const configuration = useConfigurationRQ()
  // const {
  //   rolesAllowedMenus,
  //   isFetchedGetAllowdMenus,
  //   isFetchingGetAllowdMenus,
  //   refetchRolesAllowedMenus
  // } = useGetAllowedMenus({
  //   menuIds: [
  //     "masterID",
  //     "distributerID",
  //     "productID",
  //     "subAttributeID",
  //     "skuID",
  //     "distributorID",
  //     "ForecastId",
  //     "CalenderID",
  //     "RegionWiseID",
  //     "NPStyleWiseID",
  //     "NPDBwiseID",
  //     "SEAllotmentID",
  //     "ExecutiveWiseID",
  //     "EBOForecastID",
  //     "InstitutionalID",
  //     "ExportForecastID",
  //     "OnlineForecastcastID",
  //     "AuthenticationID",
  //     "EmployeesID",
  //     "RoleID",
  //   ]
  // })

  return (
    <Routes>
      <Route path="/*" element={<LayoutRoot />} >
        <Route index element={<Navigate to={'master/product'} replace />} />
        { <Route path='master/product' element={<ProductPage />} />}
        
      </Route>

    </Routes>
  );
}

export default App;
